import { Dialog, Pane, Paragraph } from 'evergreen-ui';
import React, { memo, useCallback, useState } from 'react';
import { BehaviorSubject } from 'rxjs';
import { FatGreenOutlineButton, FatRedOutlineButton } from '../../common';
import { useObservable } from '../../rxsupport';


export function useConfirmOfferCancelDialog () {
    const [show$] = useState(() => new BehaviorSubject<boolean>(false));
    return show$;
}

type Props = {
    show$: BehaviorSubject<boolean>;
    onConfirmed: () => any;
}

export const ConfirmOfferCancelDialog = memo(function ConfirmOfferCancelDialog ({ show$, onConfirmed }: Props) {
    const show = useObservable(show$, false);

    const onClose = useCallback(() => {
        show$.next(false);
    }, [show$]);

    return (
        <Dialog
            title="Cancel Offer"
            isShown={show}
            width={510}
            hasClose={false}
            onCloseComplete={ onClose }
            contentContainerProps={ {
                textAlign: 'center'
            } }
            footer={ ({ close }) => (<>
                {/* minus the default evergreen-ui padding in footer container */}
                <Pane width={510 - 16 * 2} className="flex justify-evenly">
                    <Pane width={120}>
                        <FatRedOutlineButton text="Yes, Cancel" onClick={ () => {
                            onConfirmed();
                            close();
                        } } />
                    </Pane>

                    <Pane width={120}>
                        <FatGreenOutlineButton text="No, Go Back" onClick={ close }/>
                    </Pane>
                </Pane>
            </>) }
        >
            <Paragraph>
                Are you sure you want to cancel this offer?
            </Paragraph>
            <Paragraph>
                All the data you have entered will be lost.
            </Paragraph>
        </Dialog>
    );
});